import { ActionCreator, AnyAction, Action } from 'redux';
import { RootState } from '../modules';
import { ThunkDispatch } from 'redux-thunk';
import moment from 'moment'
import { getKeysPressed, getLocationPathName, getLastKeyTime, isSelectMultiPressed } from '../selectors/util.selector';
import { dialogActions } from './dialog.actions';
import { getSelectedLookaheadTags, getSelectedLookaheadColumn } from '../selectors/lookahead.selector';
import { ColumnType, Column } from '../components/PhasePlan/Column';
import { getSelectedPhasePlanTags, getSelectedPhasePlanColumn } from '../selectors/phaseplan.selector';
import { getCopiedLookaheadTags, getCopiedPhaseTags} from '../selectors/dialog.selector';
import { lookaheadActions } from './lookahead.actions';
import { phasePlanActions } from './phaseplan.actions';
import { TagType, SelectedTag } from '../models/ TagType';
import { Point } from '../modules/ui.reducer';
import { entityActions } from './entity.actions';
var _ = require('lodash');

export const EXPAND_PHASE_PLAN_MENU = 'EXPAND_PHASE_PLAN_MENU'
export const SET_SELECT_PRESSED = 'SET_SELECT_PRESSED'
export const KEY_DOWN_EVENT = 'KEY_DOWN_EVENT'
export const KEY_UP_EVENT = 'KEY_UP_EVENT'
export const COLUMN_SELECTED = 'COLUMN_SELECTED'
export const COLUMN_CLEAR = 'COLUMN_CLEAR'
export const KEY_CLEARED = 'KEY_CLEARED'
export const TOGGLE_HISTOGRAM = 'TOGGLE_HISTOGRAM'
export const CLEAR_PENDING_DRAG_UPDATES = 'CLEAR_PENDING_DRAG_UPDATES'
export const SHOW_PENDING_DRAG_UPDATES = 'SHOW_PENDING_DRAG_UPDATES'
export const UPDATE_ZOOM = 'UPDATE_ZOOM'

export interface ExpandPlanMenuAction extends Action {
    type: 'EXPAND_PHASE_PLAN_MENU'
    payload: {
    }
}

export interface SetSelectPressedAction extends Action {
    type: 'SET_SELECT_PRESSED'
    payload: {
        isSelected: boolean
    }
}

export interface KeyDownAction extends Action {
    type: 'KEY_DOWN_EVENT',
    payload: {
        key:string
    }
}

export interface KeyUpAction extends Action {
    type: 'KEY_UP_EVENT',
    payload: {
        key:string
    }
}

export interface KeyClearedAction extends Action {
    type: 'KEY_CLEARED',
    payload: {
    }
}

export interface ColumnSelectedAction extends Action {
    type: 'COLUMN_SELECTED',
    payload: {
        column: number,
        row: any,
        type: ColumnType
    }
}

export interface ColumnClearAction extends Action {
    type: 'COLUMN_CLEAR',
    payload: {
        
    }
}

export interface ClearPendingDragUpdates extends Action {
    type: 'CLEAR_PENDING_DRAG_UPDATES',
    payload: {

    }
}

export interface ShowPendingDragUpdates extends Action {
    type: 'SHOW_PENDING_DRAG_UPDATES',
    payload: {
        draggedId: string,
        draggedOldPoint: Point,
        draggedNewPoint: Point,
        selectedNewPoints: Array<Point>|null,
    }
}

export interface SetUpdateZoomAction extends Action {
    type: 'UPDATE_ZOOM',
    payload: {
        zoom: number
    }
}

const expandPhasePlanMenu: ActionCreator<ExpandPlanMenuAction> = ( ) => ({
    type: EXPAND_PHASE_PLAN_MENU,
    payload: {}
})

const setSelectPressedSync: ActionCreator<SetSelectPressedAction> = (isSelected: boolean) => ({
    type: SET_SELECT_PRESSED,
    payload: {
        isSelected
    }
})

const setSelectPressedAsync = (isSelected: boolean) => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
       const prevIsSelectMultiPressed = isSelectMultiPressed(getState())

       if(prevIsSelectMultiPressed != isSelected ) {
    
            dispatch(setSelectPressedSync(isSelected))
       }
    }
}

const setUpdateZoomSync: ActionCreator<SetUpdateZoomAction> = (zoom: number) => ({
    type: UPDATE_ZOOM,
    payload: {
        zoom
    }
})

const setUpdateZoomAsync = (zoom: number) => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
            dispatch(setUpdateZoomSync(zoom))
    }
}

const keyUpEvent: ActionCreator<KeyUpAction> = (key: string) => ({
    type: KEY_UP_EVENT,
    payload: {
        key
    }
    ,
    meta: {
        debounce: {
          time: 100
        }
    }
})

const keyUpEventAsync = (key: string) => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        dispatch(keyUpEvent(key))
    }
}

const columnSelected: ActionCreator<ColumnSelectedAction> = (column: number, row:any, type: ColumnType) => ({
    type: COLUMN_SELECTED,
    payload: {
        type,
        column,
        row
    },
    meta: {
        debounce: {
          time: 50
        }
    }
})

const columnClear: ActionCreator<ColumnClearAction> = () => ({
    type: COLUMN_CLEAR,
    payload: {

    },
    meta: {
        debounce: {
          time: 300
        }
    }
})

const clearPendingDragUpdates: ActionCreator<ClearPendingDragUpdates> = () => ({
    type: CLEAR_PENDING_DRAG_UPDATES,
    payload: {

    }
})

const showPendingDragUpdate: ActionCreator<ShowPendingDragUpdates> = (tagId: string, newPoint:Point, oldPoint:Point, selectedNewPoints: Array<Point>|null) => ({
    type: SHOW_PENDING_DRAG_UPDATES,
    payload: {
        draggedId: tagId,
        draggedOldPoint: oldPoint,
        draggedNewPoint: newPoint,
        selectedNewPoints: selectedNewPoints,
    },
    meta: {
        debounce: {
          time: 100
        }
    }
})



const columnSelectedAsync =  (column: number, row:any, type: ColumnType) => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        dispatch(columnSelected(column, row, type))
    }
}

const columnClearAsync = () => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        const state = getState();
        const selectedLookaheadColumn = getSelectedLookaheadColumn(state);
        const selectedPhasePlanColumn = getSelectedPhasePlanColumn(state);
        if(selectedLookaheadColumn !== null || selectedPhasePlanColumn !== null)
            dispatch(columnClear())
    }
}

const keyClearedEvent: ActionCreator<KeyClearedAction> = () => ({
    type: KEY_CLEARED,
    payload: {
        
    },
    meta: {
        debounce: {
          time: 100
        }
    }
})

const COPY = new Set<string>(['c', 'C'])
const PASTE = new Set<string>(['v', 'V'])
const COPY_WIN = new Set<string>(['c', 'Control'])
const PASTE_WIN = new Set<string>(['v', 'Control'])
const DELETE =new Set<string>(['Backspace'])
const DELETE_WIN =new Set<string>(['Backspace', 'Control'])
const RIP =new Set<string>(['r', 'R'])
const RIP_WIN =new Set<string>(['r', 'Control'])
const DUPLICATE =new Set<string>(['d', 'D'])
const DUPLICATE_WIN =new Set<string>(['d', 'Control'])

const CREATE_TRADE =new Set<string>(['m', 'm'])
const CREATE_TRADE_WIN =new Set<string>(['m', 'Control'])
const CREATE_TAG =new Set<string>(['n', 'N'])
const CREATE_TAG_WIN =new Set<string>(['n', 'Control'])

export const HISTOGRAM = new Set<string>(['a', 'A'])
export const HISTOGRAM_WIN = new Set<string>(['a', 'Control'])
export const HISTOGRAM_WIN_ALT = new Set<string>(['a', 'Shift'])


export const UNDO = new Set<string>(['z', 'Z'])
export const UNDO_WIN = new Set<string>(['z', 'Control'])
export const UNDO_WIN_ALT = new Set<string>(['z', 'Shift'])

export const REDO = new Set<string>(['x', 'x'])
export const REDO_WIN = new Set<string>(['x', 'Control'])
export const REDO_WIN_ALT = new Set<string>(['x', 'Shift'])


export const ISLOCKEDDOWN  = new Set<string>(['l', 'L'])


const HELP_INFO = new Set<string>(['s', 'S'])

export const SHORT_CUT = [
    COPY,
    COPY_WIN,
    PASTE,
    PASTE_WIN,
    DELETE,
    DELETE_WIN,
    RIP,
    RIP_WIN,
    DUPLICATE,
    DUPLICATE_WIN,
    CREATE_TRADE,
    CREATE_TRADE_WIN,
    CREATE_TAG,
    CREATE_TAG_WIN,
    HISTOGRAM,
    HISTOGRAM_WIN,
    HISTOGRAM_WIN_ALT,
    ISLOCKEDDOWN
]

const keyDownEventAsync = (event:any, key: string) => {
    
    return (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {

        const state = getState()

        const lastKeyTime = getLastKeyTime(state)
        const currentTime = Date.now();

        /*if (currentTime - lastKeyTime > 15000) {
            dispatch(keyClearedEvent())
            dispatch({
                type: KEY_DOWN_EVENT,
                payload: {
                    key,
                    lastKeyTime: currentTime
                },
                meta: {
                    debounce: {
                        time: 300
                    }
                }
            })
            return
        }*/

        if(key === 'Meta' || key === 'Control' || key === 'Shift') {
            dispatch(keyClearedEvent())

            dispatch({
                type: KEY_DOWN_EVENT,
                payload: {
                    key,
                    lastKeyTime: currentTime
                },
                meta: {
                    debounce: {
                        time: 300
                    }
                }
            })
            return
        }

        const pathName = getLocationPathName(state)

        if(COPY.has(key)) {
            
            if(pathName === '/lookahead') {
                event.preventDefault()
                const selectedTags = getSelectedLookaheadTags(state)

                dispatch(dialogActions.copyTags(selectedTags, ColumnType.Lookahead))
            }

            if(pathName === '/phasePlan') {
                event.preventDefault()
                const selectedTags:Record<string, SelectedTag> = getSelectedPhasePlanTags(state)

                dispatch(dialogActions.copyTags(selectedTags, ColumnType.PhasePlan))
            }
        }

        if(PASTE.has(key)) {
            if(pathName === '/lookahead') {
                event.preventDefault()
                const copiedTags = getCopiedLookaheadTags(state)
                const selectedColumn = getSelectedLookaheadColumn(state)

                dispatch(dialogActions.pasteTags(false, ColumnType.Lookahead))
            }

            if(pathName === '/phasePlan') {
                event.preventDefault()
                const copiedTags = getCopiedPhaseTags(state)
                const selectedColumn = getSelectedPhasePlanColumn(state)

                dispatch(dialogActions.pasteTags(false, ColumnType.PhasePlan))
            }
        }

        if( HISTOGRAM.has(key)) {
            if(pathName === '/lookahead') {
                event.preventDefault()
                dispatch(lookaheadActions.lookaheadHistogramToggle())
            }

            if(pathName === '/phasePlan') {
                event.preventDefault()
                dispatch(phasePlanActions.phasePlanHistogramToggle())
            }
        }

        if(HELP_INFO.has(key)) {
            dispatch(dialogActions.openHelpInfoDialog())
        }
        
        if(DELETE.has(key)) {
            if(pathName === '/lookahead') {
                event.preventDefault()
                const selectedTags:Record<string, SelectedTag> = getSelectedLookaheadTags(state)

                dispatch(dialogActions.showDeleteTagDialog(selectedTags, ColumnType.Lookahead))
            }

            if(pathName === '/phasePlan') {
                event.preventDefault()
                const selectedTags:Record<string, SelectedTag> = getSelectedPhasePlanTags(state)

                dispatch(dialogActions.showDeleteTagDialog(selectedTags, ColumnType.PhasePlan))
            }
        }

        if(DUPLICATE.has(key)) {
            if(pathName === '/lookahead') {
                event.preventDefault()

                const arraySelectTags = state.lookaheadReducer.selectedTags;
                const tagIdObj = {}; 
                if (!!Object.keys(arraySelectTags).length) {
                    for(let tag in arraySelectTags) {
                        tagIdObj[tag] =  {
                                position: {
                                    column: arraySelectTags[tag].position.column,
                                    row: arraySelectTags[tag].position.row,
                                },
                                tagCardType: arraySelectTags[tag].tagCardType,
                                tagId: tag
                            }
                    }
                    dispatch(entityActions.duplicateTag(tagIdObj, ColumnType.Lookahead))
                }
            }

            if(pathName === '/phasePlan') {
                event.preventDefault()

                const arraySelectTags = state.phasePlanReducer.selectedTags;
                const tagIdObj = {}; 
                if (!!Object.keys(arraySelectTags).length) {
                    for(let tag in arraySelectTags) {
                        tagIdObj[tag] = {
                            position: {
                                column: arraySelectTags[tag].position.column,
                                row: arraySelectTags[tag].position.row,
                            },
                            tagCardType: arraySelectTags[tag].tagCardType,
                            tagId: tag
                        }  
                    }
                    dispatch(entityActions.duplicateTag(tagIdObj, ColumnType.PhasePlan))
                }                
            }
        }

        if(CREATE_TAG.has(key)) {
            if(pathName === '/lookahead') {
                event.preventDefault()
                dispatch(lookaheadActions.lookaheadDialogOpen(null))
            }

            if(pathName === '/phasePlan') {
                event.preventDefault()
                dispatch(dialogActions.showTagDialog(null))

            }
        }

        if(UNDO.has(key)) {
            event.preventDefault()
            dispatch(lookaheadActions.undoTag())
        }

        if(REDO.has(key)) {
            event.preventDefault()
            dispatch(lookaheadActions.redoTag())
        }

        if(CREATE_TRADE.has(key)) {
            if(pathName === '/lookahead') {
                event.preventDefault()
                dispatch(dialogActions.showTradeDialog(null))
            }

            if(pathName === '/phasePlan') {
                event.preventDefault()

                dispatch(dialogActions.showTradeDialog(null))
            }
        }



        if(RIP.has(key)) {

            if(pathName === '/phasePlan') {
                event.preventDefault()
                const selectedTags:Record<string, SelectedTag> = getSelectedPhasePlanTags(state)
                if(Object.keys(selectedTags).length > 0) {
                    const tagId = Object.keys(selectedTags)[0]
                    const tagType = selectedTags[tagId]
                    dispatch(dialogActions.showRipTagDialog(Object.keys(selectedTags)[0], tagType))
                }

            }
        }

        if(ISLOCKEDDOWN.has(key)) {
            if(pathName === '/lookahead') {
                event.preventDefault()
                dispatch(lookaheadActions.lockDownPlan())
            }
        }

        dispatch({
            type: KEY_DOWN_EVENT,
            payload: {
                key,
                lastKeyTime: currentTime
            },
            meta: {
                debounce: {
                    time: 300
                }
            }
        })
    }
}

export type UIAction = ExpandPlanMenuAction | SetSelectPressedAction | KeyUpAction | KeyDownAction

export const expandPhasePlanMenuAction = () => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        
        return dispatch(expandPhasePlanMenu())
    }
}

export const clearPendingDragUpdatesAsync = () => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        dispatch(clearPendingDragUpdates())
    }
}

export const showPendingDragUpdatesAsync = (tagId:string, newPosition: Point, oldPosition: Point) => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        const state = getState()
        const pathName = getLocationPathName(state)
        let selectedNewPositions = null;
        if(pathName === '/lookahead') {
            const selectedTags = getSelectedLookaheadTags(state)
            if(Object.keys(selectedTags).length > 0)
                selectedNewPositions = adjustLookaheadSelectedTagPositions(newPosition, oldPosition, selectedTags)
        }
        dispatch(showPendingDragUpdate(tagId, newPosition, oldPosition, selectedNewPositions))
    }
}

function adjustLookaheadSelectedTagPositions(draggedNewPoint, draggedOldPoint, selectedTags){
    
    //Get the dragged tag column and index
    const newColumnId = draggedNewPoint.column
    const newIndexId = draggedNewPoint.row
    const oldColumnId = draggedOldPoint.column
    const oldIndexId = draggedOldPoint.row

    if (newIndexId !== 0 && !newIndexId) return null;

    //Calculate the column offset and index offset new - old = offset
    let offsetColumn: number
    let offsetIndex: number

    const newColumnMoment = moment(newColumnId)
    const oldColumnMoment = moment(oldColumnId)

    // only for pathName /lookahead
    offsetColumn = newColumnMoment.diff(oldColumnMoment, 'days')

    offsetIndex = newIndexId - oldIndexId

    // adjust their column and index by adding offset old + offset = new
    const adjustedSelectedTagList = Object.keys(selectedTags).map(tagId => {
        const tag = selectedTags[tagId]

        // only for pathName /lookahead
        const newColumn = moment(tag.position.column).add(offsetColumn, 'days').valueOf()

        const newRow = parseInt(tag.position.row, 10) + parseInt(offsetIndex, 10)

        return {
            column: newColumn,
            row: newRow
        }
    })
    
    //console.log('adjustedSelectedTagList', adjustedSelectedTagList)
    //adjustedSelectedTagList.map(({ column, row }) => { console.log('column', column, moment(column).format('l'), 'row', row) });

    return adjustedSelectedTagList;
};


export const uiActions = {
    expandPhasePlanMenuAction,
    setSelectPressedAsync,
    keyDownEventAsync,
    keyUpEventAsync,
    columnSelectedAsync,
    columnClearAsync,
    keyClearedEvent,
    showPendingDragUpdatesAsync,
    clearPendingDragUpdatesAsync,
    setUpdateZoomAsync
}


// WEBPACK FOOTER //
// ./src/actions/ui.actions.ts